import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { expertProfileApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertProfileFormData } from '../types/expert-profile';

export function useCreateExpertProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: ExpertProfileFormData) =>
      expertProfileApi.createExpertProfile(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.expertProfiles.lists() });
      toast.success('Expert profile created successfully!');
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to create expert profile');
    },
  });
}
